module.exports = __webpack_public_path__ + "static/media/level-0.0251c373.glb";